/**
 * Languages of a project's drawings: French, English, Dutch and (decision 0017) German, for the
 * German-speaking Community of East Belgium.
 */
export type Locale = 'fr' | 'en' | 'nl' | 'de';

/**
 * Text for a language from its versions: tr(locale, 'Tableau', 'Board', 'Bord', 'Verteiler').
 * Without a German version, German drawings show the French one.
 */
export const tr = (l: Locale, fr: string, en: string, nl: string, de?: string): string =>
  l === 'fr' ? fr : l === 'nl' ? nl : l === 'de' ? (de ?? fr) : en;

/** BCP 47 tag for dates and numbers: Belgian French, Dutch and German, British English. */
export const localeTag = (l: Locale): string =>
  l === 'fr' ? 'fr-BE' : l === 'nl' ? 'nl-BE' : l === 'de' ? 'de-BE' : 'en-GB';
